'use client';

import { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/navigation';
import { Check } from 'lucide-react';

interface PackStandardVirtuelCardProps {
  isAnnual: boolean;
}

const AFTER_TRIAL_MONTHLY = 14.9;
const AFTER_TRIAL_YEARLY = 149;

const FEATURES = [
  '1 numéro fixe France (01, 02, 03, 04, 05, 09 et DOM-TOM) ou conservez le vôtre avec la portabilité',
  'Appels entrants illimités et renvoi d’appels illimité vers des lignes fixes et mobiles en France métropolitaine et dans les DOM-TOM',
  'Abonnement sans engagement',
  'Serveur vocal interactif: Pré-décroché, musique d’attente, renvoi d’appels, gestion des horaires, etc.',
  'Journal d’appel et espace client web & mobile',
  'Activation 100 % en ligne',
];

export function PackStandardVirtuelCard({ isAnnual }: PackStandardVirtuelCardProps) {
  const router = useRouter();
  const [isNavigating, setIsNavigating] = useState(false);

  const after = isAnnual ? AFTER_TRIAL_YEARLY : AFTER_TRIAL_MONTHLY;
  const period = isAnnual ? 'an' : 'mois';

  const commandeHref = useMemo(() => {
    const offer = isAnnual ? 'std_virt_y' : 'std_virt_m';
    return `/commande?type=commande&offer=${offer}`;
  }, [isAnnual]);

  useEffect(() => {
    router.prefetch(commandeHref);
  }, [router, commandeHref]);

  const handleSubscribe = () => {
    setIsNavigating(true);
    router.push(commandeHref);
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg border-2 border-primaryGreen overflow-hidden flex flex-col h-full">
      <div className="bg-primaryGreen text-white p-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
            <img src="/pack-std.png" alt="" className="w-10 h-10 object-contain" />
          </div>
          <div>
            <h3 className="text-xl font-bold">Pack Standard Virtuel Illimité</h3>
          </div>
        </div>
      </div>

      <div className="p-6 flex-1 flex flex-col">
        <div className="mb-6 text-center space-y-2">
          <p className="text-xs font-medium text-primaryGreen">
            {isAnnual ? 'Annuel' : 'Mensuel'}
          </p>
          <p className="text-lg text-gray-800 leading-snug">
            <span className="font-bold text-primaryGreen">Essai gratuit</span> pendant 7 jours puis{' '}
            <span className="font-bold">
              {after.toFixed(2).replace('.', ',')} € HT/{period}
            </span>
          </p>
        </div>

        <ul className="space-y-3 mb-6 flex-1">
          {FEATURES.map((feature, index) => (
            <li key={index} className="flex items-start gap-3">
              <Check className="w-5 h-5 text-primaryGreen flex-shrink-0 mt-0.5" />
              <span className="text-sm text-gray-700 text-left">{feature}</span>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={handleSubscribe}
          disabled={isNavigating}
          className="w-full py-3 px-6 bg-primaryGreen text-white font-semibold rounded-full hover:bg-primaryGreen/90 transition-colors disabled:opacity-70"
        >
          {isNavigating ? 'Chargement…' : 'Démarrer mon essai maintenant'}
        </button>
      </div>
    </div>
  );
}
